module.exports = __webpack_public_path__ + "img/porto-bellagio-condos.ed77c033.jpg";